import React, { useState } from "react";
import { Grid, Icon } from 'semantic-ui-react';
import { epochToDateTime } from "../../util/index";
import StatusDetailEdiResponse from "./StatusDetailEdiResponse";

const ReconStatusDetailLayout = ({formData}) => {
    const {tranctionType, ediRequestDate, cbpStatus, ediResponseId} = formData;
    const [statusDetailExpanded, setStatusDetailExpanded] = useState(false);
    const expandArrowName = !statusDetailExpanded ? "arrow alternate circle down outline" : "arrow alternate circle up outline"
    const expandOnClick = () => {
        setStatusDetailExpanded(!statusDetailExpanded);
    }
    return ( 
        <>
            <Grid.Row className="status-detail-row">
                <Icon size='large' className="status-detail-expandicon" onClick={expandOnClick} name={expandArrowName} />
                <Grid.Column>
                    <b>Transmission Type</b>: {tranctionType}
                </Grid.Column>
                <Grid.Column>
                <b>Transmission Date</b>: {epochToDateTime(ediRequestDate)}
                </Grid.Column>
                <Grid.Column>
                <b>CBP Status</b>: {cbpStatus}
                </Grid.Column>
                <Grid.Column>
                <b>CBP Message</b>
                </Grid.Column>
                {statusDetailExpanded && <Grid.Row>
                    {ediResponseId ? <StatusDetailEdiResponse ediResponseId={ediResponseId} /> : <div>Response Id For this Status detail is not found!</div>}
            </Grid.Row>}
            </Grid.Row>
        </>
     );
}
 
export default ReconStatusDetailLayout;